import React, { useState } from "react";
import ReactDOM from "react-dom";

const TempPasswordModal = ({ open, email, password, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.log(err);
    }
  };

  return ReactDOM.createPortal(
    <div className="bini-modal-overlay">
      <div className="bini-modal" role="dialog" aria-modal="true" style={{ width: 460 }}>
        <div className="bini-modal-title">Password temporal generada</div>

        {email && (
          <div style={{ color: "var(--bini-text-secondary)", fontSize: 11, marginBottom: 14 }}>
            Para: <span style={{ color: "var(--bini-text-primary)", fontWeight: 500 }}>{email}</span>
          </div>
        )}

        <div style={{ display: "flex", gap: 8, alignItems: "stretch" }}>
          <div
            className="bini-mono"
            style={{
              flex: 1,
              background: "var(--bini-bg-input)",
              border: "1px solid var(--bini-purple)",
              borderRadius: 4,
              padding: "10px 12px",
              fontSize: 14,
              color: "var(--bini-text-primary)",
              userSelect: "all",
              wordBreak: "break-all",
            }}
          >
            {password}
          </div>
          <button
            className="bini-btn bini-btn-edit"
            onClick={handleCopy}
            style={{ minWidth: 80 }}
          >
            {copied ? "Copiado ✓" : "Copiar"}
          </button>
        </div>

        <div className="bini-warning" style={{ marginTop: 12 }}>
          <div className="t">⚠ Esta es la única vez que verás esta password</div>
          <div className="d">Copiala y compartila con el usuario por un canal seguro antes de cerrar.</div>
        </div>

        <div className="bini-modal-actions">
          <button className="bini-btn bini-btn-save" onClick={onClose}>
            Confirmar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TempPasswordModal;
